module.exports = __webpack_public_path__ + "img/bagel.854d43dd.svg";